<template>
  <section class="w-screen h-screen absolute flex justify-center items-center z-50">
    <div id="modal modal-table"
      class="modal absolute block bg-white dark:bg-dark-800 w-5/6 sm:w-9/12 md:w-5/12 max-w-lg shadow-md rounded-lg dark:shadow-dark-600"
      :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
      }">
      <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">{{ isEdit ? 'Edit Global Discount' : 'Tambah Global Discount' }}</h5>
      </div>
      <div id="modal-body" class="p-5 space-y-4 max-h-[calc(100dvh-220px)] overflow-y-auto">
        <InputTextCustom v-model="name" id="table-name" label="Nama Global Discount" placeholder="Masukkan nama"
          input_class="w-full" :valid="validation.name.valid" :error-message="validation.name.message" />
        <InputTextCustom v-model="amount" id="item-price" label="Amount" input_class="w-full"
          :valid="validation.amount.valid" :error-message="validation.amount.message" type="number" />
        <InputRadio v-model="needPin" id="need-pin" name="need-pin" label="Pin"
          :options="[{ value: true, label: 'Ya' }, { value: false, label: 'Tidak' }]"
          :valid="validation.need_pin.valid" :error-message="validation.need_pin.message" />
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600" @click="closeModal" />
          <SubmitButton id="submit" button_name="Submit" button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4"
            @click="submitGlobalDiscount" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import InputRadio from '../form/InputRadio.vue';
import InputTextCustom from '../form/InputTextCustom.vue';
import SubmitButton from '../form/SubmitButton.vue';
import { mapActions } from 'vuex';

export default {
  name: "ModalGlobalDiscount",
  props: {
    globalDiscount: {
      type: Object,
      default: null,
    }
  },
  components: {
    SubmitButton, InputTextCustom, InputRadio
  },
  data() {
    return {
      showModal: true,
      name: this.globalDiscount ? this.globalDiscount.name : '',
      amount: this.globalDiscount ? this.globalDiscount.amount : 0,
      isPercentage: this.globalDiscount ? this.globalDiscount.isPercentage : true,
      needPin: this.globalDiscount ? this.globalDiscount.need_pin : false,
      statusOptions: [
        { name: 'Kosong', code: 'available' },
        { name: 'Terisi', code: 'unavailable' }
      ],
      field: ['name', 'amount', 'is_percentage', 'need_pin'],
      validation: {
        name: {
          valid: true,
          message: ''
        },
        amount: {
          valid: true,
          message: ''
        },
        need_pin: {
          valid: true,
          message: ''
        }
      },
      isEdit: !!this.globalDiscount
    }
  },
  watch: {
    globalDiscount(newVal) {
      if (newVal) {
        this.name = newVal.name;
        this.amount = newVal.capacity;
        this.isPercentage = newVal.is_percentage;
        this.needPin = newVal.need_pin;
        this.isEdit = true;
      } else {
        this.name = '';
        this.amount = 1;
        this.isPercentage = true;
        this.needPin = null;
        this.isEdit = false;
      }
    }
  },
  methods: {
    ...mapActions('global_discounts', ['createGlobalDiscount', 'updateGlobalDiscount']),
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200);
    },
    submitGlobalDiscount() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan diskon global?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postGlobalDiscount();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan diskon global', life: 3000 });
        }
      });
    },
    async postGlobalDiscount() {
      try {
        const tableData = {
          name: this.name,
          amount: parseFloat(this.amount),
          need_pin: this.needPin
        };

        if (this.isEdit && this.globalDiscount) {
          tableData.id = this.globalDiscount.id;
          await this.updateGlobalDiscount(tableData);
        }
        else {
          tableData.is_percentage = true;
          await this.createGlobalDiscount(tableData);
        }

        this.closeModal();
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Diskon Global berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save table:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    }
  }
}
</script>
